import { Buildings, Key, Sparkle, Bed, Wrench, UsersThree, HandHeart, ShieldCheck } from "@phosphor-icons/react";
import { Reveal, Overline } from "@/components/Reveal";
import { useLang } from "@/i18n";

const ICONS = { Buildings, Key, Sparkle, Bed, Wrench, UsersThree, HandHeart, ShieldCheck };

export default function Services() {
  const { t } = useLang();
  return (
    <section id="servizi" data-testid="services-section" className="bg-ivory py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <Reveal>
          <Overline>{t.services.overline}</Overline>
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <h2 className="max-w-2xl font-serif text-4xl font-light leading-[1.08] tracking-tight text-navy md:text-5xl lg:text-6xl">
              {t.services.title}
            </h2>
            <p className="max-w-sm text-sm font-light leading-relaxed text-navy/60 md:text-base">{t.services.sub}</p>
          </div>
        </Reveal>

        <Reveal delay={0.15} className="mt-16 md:mt-20">
          <div className="grid grid-cols-1 gap-px border border-champagne/25 bg-champagne/25 sm:grid-cols-2 lg:grid-cols-4">
            {(t.services.items || []).map((s, i) => {
              const Icon = ICONS[s.icon];
              return (
                <div
                  key={s.title}
                  data-testid={`service-card-${i + 1}`}
                  className="group relative bg-ivory p-10 transition-colors duration-500 hover:bg-navy"
                >
                  <span className="text-[11px] font-medium tracking-[0.3em] text-champagne">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <Icon size={38} weight="light" className="mt-8 text-navy transition-colors duration-500 group-hover:text-champagne" />
                  <h3 className="mt-6 font-serif text-2xl font-light tracking-tight text-navy transition-colors duration-500 group-hover:text-ivory">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm font-light leading-relaxed text-navy/60 transition-colors duration-500 group-hover:text-ivory/65">
                    {s.text}
                  </p>
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
